import {
  CAMPAIGN_CONFIGURATION_SUBMITTED,
  CAMPAIGN_RESET,
  CAMPAIGN_REWARDS_GENERATED,
} from '../actionTypes';

export const createCampaignConfigurationSubmit = ({
  tokenAddress,
  tokensPerCode,
  numberOfCodes,
  name,
  totalTokens,
}) => ({
  type: CAMPAIGN_CONFIGURATION_SUBMITTED,
  tokenAddress,
  tokensPerCode,
  numberOfCodes,
  name,
  totalTokens,
});

export const rewardsGenerated = rewards => ({
  type: CAMPAIGN_REWARDS_GENERATED,
  rewards,
});

export const campaignReset = () => ({
  type: CAMPAIGN_RESET,
});



// WEBPACK FOOTER //
// ./src/actions/createCampaign.js